import React, { useRef, useState, useEffect } from "react";
import "./ImageUpload.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTrash, faFile } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const DocUpload = (props) => {
  const [FileLink, setFileLink] = useState("");
  const [FileID, setFileID] = useState("");
  const [PreviewUrl, setPreviewUrl] = useState(false);
  const [IsValid, setIsValid] = useState(false);

  const { File, setFile } = props;

  const filePickerRef = useRef();

  // useEffect(() => {
  //     PreviewUrl(true);
  //     setFileLink(File);
  // }, [File]);

  const DeleteDocument = async (FilePath) => {
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/uploaddocs/" +
            localStorage.getItem("_id") +
            "/" +
            FileID,
          {
            FileLink,
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          alert(res.data.message);
          setFileLink("");
          setFileID("");
          setPreviewUrl(false);
          props.HandleOtherText("", "Flink");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const DocUploadHandler = async (DocFile, isValid) => {
    const formData = new FormData();
    formData.append("DOC", DocFile);
    if (DocFile.size < 60000000) {
      axios
        .post(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/uploaddocs/" +
            localStorage.getItem("_id"),
          formData,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          setFileLink(res.data.file);
          setFileID(res.data.doc._id);
          props.HandleOtherText(res.data.file, "Flink");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = IsValid;
    if (event.target.files || event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setFile(pickedFile);
      setIsValid(true);
      fileIsValid = true;
    } else {
      setIsValid(false);
      fileIsValid = false;
    }
    DocUploadHandler(pickedFile, fileIsValid);
  };

  const pickImageHandler = () => {
    filePickerRef.current.click();
  };

  return (
    <div>
      <input
        ref={filePickerRef}
        style={{ display: "none" }}
        type="file"
        accept=".ppt,.pptx,.doc,.docx,.pdf,.xls,.xlsx"
        onChange={pickedHandler}
      />
      {PreviewUrl && (
        <Button variant="danger" onClick={() => DeleteDocument(FileLink)}>
          {" "}
          <FontAwesomeIcon icon={faTrash} className="sidebar-icon" /> Delete
          File
        </Button>
      )}

      {!PreviewUrl && (
        <Button onClick={pickImageHandler}>
          <FontAwesomeIcon icon={faUpload} className="sidebar-icon" /> Attach
          File
        </Button>
      )}
    </div>
  );
};

export default DocUpload;
